<template>
  <head>
    <meta charset="utf-8" />
    <title>NTSA | Users </title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Keep your finances and membership up to date" name="description" />
    <meta content="" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="./assets/images/favicon.svg">

    <!-- DataTables -->
    <link href="./assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="./assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap Css -->
    <link href="./assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="./assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="./assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="./assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body @contextmenu.prevent data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <NavigationBar/>

    <!-- Start right Content here -->
    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Users Register</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboards</a></li>
                    <li class="breadcrumb-item active">User's Register</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- Password Expiry Summary Cards -->
          <div class="row mb-4">
            <div class="col-xl-3 col-md-6">
              <div class="card border-0 shadow-sm">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Critical (≤7 days)</p>
                      <h4 class="mb-0 text-danger">{{passwordStats.critical}}</h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-danger bg-opacity-10">
                          <span class="avatar-title rounded-circle bg-transparent text-danger">
                            <i class="mdi mdi-alert-circle font-size-16"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="card border-0 shadow-sm">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Warning (8-30 days)</p>
                      <h4 class="mb-0 text-warning">{{passwordStats.warning}}</h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-warning bg-opacity-10">
                          <span class="avatar-title rounded-circle bg-transparent text-warning">
                            <i class="mdi mdi-clock-alert font-size-16"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="card border-0 shadow-sm">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Good (>30 days)</p>
                      <h4 class="mb-0 text-success">{{passwordStats.good}}</h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-success bg-opacity-10">
                          <span class="avatar-title rounded-circle bg-transparent text-success">
                            <i class="mdi mdi-check-circle font-size-16"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="card border-0 shadow-sm">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">With Signatures</p>
                      <h4 class="mb-0 text-info">{{signatureStats.withSignature}}</h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-info bg-opacity-10">
                          <span class="avatar-title rounded-circle bg-transparent text-info">
                            <i class="mdi mdi-draw font-size-16"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Users table -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <h4 class="mb-0">Registered Users</h4>
                    <div v-if="getRight('CREATE USER')" class="d-flex gap-2">
                      <!-- Download Buttons Group -->
                      <div class="btn-group" role="group">
                        <!-- Download Current Page -->
                        <button
                            @click="downloadCurrentPage()"
                            type="button"
                            class="btn btn-success"
                            :disabled="filteredUsers.length === 0">
                          <i class="mdi mdi-download font-size-10"></i>
                          <span class="d-md-inline ms-1">Current Page ({{filteredUsers.length}})</span>
                        </button>

                        <!-- Download All Users -->
                        <button
                            @click="downloadAllUsers()"
                            type="button"
                            class="btn btn-primary"
                            :disabled="isDownloadingAll || !summary || summary.count === 0">
                          <span v-if="isDownloadingAll">
                            <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                            Downloading...
                          </span>
                          <span v-else>
                            <i class="mdi mdi-cloud-download font-size-10"></i>
                            <span class="d-md-inline ms-1">All ({{numberFormat(summary ? summary.count : 0)}})</span>
                          </span>
                        </button>
                      </div>

                      <div>
                        <a @click="gotTo('add-users')" type="button" class="btn btn-primary dropdown-toggle option-selector">
                          <i class="mdi mdi-account-multiple-plus-outline font-size-16"></i>
                          <span class="pl-1 d-md-inline">Add User(s)</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Enhanced Filter Section -->
                <div class="card-header bg-white w-100 border-bottom">
                  <div class="row align-items-center">
                    <!-- System Filter -->
                    <div class="col-md-2">
                      <select class="form-select form-control bg-white" title="Filter by System" v-model="selectedSystem" @change="handleSystemFilterChange">
                        <option value="">All Systems</option>
                        <option v-for="system in systems" :key="system.id" :value="system.id">
                          {{system.name}}
                        </option>
                      </select>
                    </div>

                    <!-- Facility Filter (Hospital Only) -->
                    <div class="col-md-2" v-if="selectedSystem == 2">
                      <select class="form-select form-control bg-white" title="Filter by Facility" v-model="selectedFacilityFilter">
                        <option value="">All Facilities</option>
                        <option v-for="facility in facilities" :key="facility.facilityID" :value="facility.facilityID">
                          {{facility.facilityName}}
                        </option>
                      </select>
                    </div>

                    <div class="col-md-2">
                      <select class="form-select form-control bg-white" title="Select System User Type" v-model="selectedItem">
                        <option selected value="">All users ({{users.length}})</option>
                        <option v-for="(item, index) in categories" :value="item.category" :key="index">{{item.category}}(<b>{{item.count}}</b>)</option>
                      </select>
                    </div>

                    <div class="col-md-2">
                      <select class="form-select form-control bg-white" title="Filter by Password Expiry" v-model="passwordFilter">
                        <option value="">All Password Status</option>
                        <option value="critical">Critical (≤7 days)</option>
                        <option value="warning">Warning (8-30 days)</option>
                        <option value="good">Good (>30 days)</option>
                        <option value="expired">Expired</option>
                      </select>
                    </div>

                    <div class="col-md-2">
                      <select class="form-select form-control bg-white" title="Filter by Status" v-model="statusFilter">
                        <option value="">All Status</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                        <option value="Disabled">Disabled</option>
                      </select>
                    </div>

                    <div class="col-md-2">
                      <div class="search-box mb-0 me-2 flex-grow-1">
                        <div class="position-relative">
                          <input v-model="search" type="text" class="form-control bg-light border-light rounded" placeholder="Search User">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table align-middle table-nowrap table-hover contacts-table table-striped" id="">
                      <thead class="table-dark">
                      <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Contact</th>
                        <th scope="col">System</th>
                        <th scope="col">Facility</th>
                        <th scope="col">Location</th>
                        <th scope="col">Password Status</th>
                        <th scope="col">Last Seen</th>
                        <th scope="col">Status</th>
                        <th scope="col">Approved</th>
                        <th scope="col">Actions</th>
                      </tr>
                      </thead>

                      <tbody>
                      <tr v-for="(item, index) in paginatedUsers" :value="item" :key="index"
                          :class="getPasswordExpiryRowClass(item.passwordExpiry)">
                        <td>
                          <a @click="logs(item.idNo,item.names)" title="click to view user logs and activities">
                            <div class="d-flex align-items-center">
                              <div class="avatar-xs me-3">
                                    <span class="avatar-title rounded-circle bg-primary">
                                      {{item.names[0]}}
                                    </span>
                              </div>
                              <div>
                                <h5 class="font-size-14 mb-1">
                                  <a href="javascript: void(0);" class="text-dark text-capitalize">{{item.names}}</a>
                                </h5>
                                <p class="text-muted mb-0">{{item.category}}</p>
                                <small class="text-muted">ID: {{item.idNo}}</small>
                              </div>
                            </div>
                          </a>
                        </td>

                        <td>
                          <div class="d-flex flex-column">
                            <p class="text-muted mb-1">
                              <i class="mdi mdi-phone font-size-12 me-1"></i>
                              <a :href="'tel:' + item.phoneNumber">{{maskPhoneNumber(item.phoneNumber)}}</a>
                            </p>
                            <p class="mb-0">
                              <i class="mdi mdi-email font-size-12 me-1"></i>
                              <a :href="'mailto:' + item.email">{{item.email}}</a>
                            </p>
                            <small v-if="item.requireOTP === 'true'" class="text-info">
                              <i class="mdi mdi-shield-check"></i> OTP Required
                            </small>
                          </div>
                        </td>

                        <!-- System Column -->
                        <td>
                          <span :class="getSystemBadgeClass(item.systemID)" class="badge">
                            <i :class="getSystemIcon(item.systemID)" class="me-1"></i>
                            {{ getSystemName(item.systemID) }}
                          </span>
                        </td>

                        <!-- Facility Column -->
                        <td>
                          <div v-if="item.systemID == 2">
                            <span v-if="item.facilityAccess === 'ALL'" class="badge bg-info">
                              <i class="mdi mdi-hospital-building me-1"></i>All Facilities
                            </span>
                            <div v-else-if="item.facilityName">
                              <strong class="text-primary">{{ item.facilityName }}</strong>
                              <br>
                              <small class="text-muted">{{ item.facilityCode }}</small>
                              <span v-if="hasMultipleFacilities(item)" class="badge bg-secondary ms-1">
                                +{{ getAdditionalFacilityCount(item) }}
                              </span>
                            </div>
                            <span v-else class="text-muted">
                              <i class="mdi mdi-alert-circle-outline me-1"></i>Not Assigned
                            </span>
                          </div>
                          <span v-else class="text-muted">N/A</span>
                        </td>

                        <td class="text-capitalize">
                          <div>
                            <strong>{{item.subCountyName || 'N/A'}}</strong>
                            <br>
                            <small class="text-muted">{{item.wardName || 'N/A'}}</small>
                            <br>
                            <small class="text-info">{{item.zone || 'N/A'}}</small>
                          </div>
                        </td>

                        <td>
                          <div class="password-expiry-info">
                                <span :class="getPasswordExpiryBadgeClass(item.passwordExpiry)" class="badge password-days-badge">
                                  {{getPasswordExpiryText(item.passwordExpiry)}}
                                </span>
                            <br>
                            <small class="text-muted mt-1">
                              Expires: {{formatDate(item.passwordExpiry)}}
                            </small>
                          </div>
                        </td>

                        <td class="text-capitalize">
                          <div>
                            {{getHumanDate(item.lastSeen)}}
                            <br>
                            <small class="text-muted">{{item.address || 'No address'}}</small>
                          </div>
                        </td>

                        <td>
                              <span v-if="item.status==='Active'"
                                    style="cursor: pointer;"
                                    class="badge badge-soft-success text-uppercase status-badge"
                                    @click="openDisableModal(item)">
                                <i class="mdi mdi-check-circle font-size-10 me-1"></i>{{item.status}}
                              </span>
                          <span v-if="item.status !=='Active'"
                                style="cursor: pointer;"
                                class="badge badge-soft-danger text-uppercase status-badge"
                                @click="openDisableModal(item)">
                                <i class="mdi mdi-close-circle font-size-10 me-1"></i>{{item.status}}
                              </span>
                        </td>

                        <td>
                              <span @click="approvedUser(item)"
                                    v-if="item.approved==='true'"
                                    style="cursor: pointer;"
                                    class="badge badge-soft-success text-uppercase status-badge">
                                <i class="mdi mdi-check-circle font-size-10 me-1"></i>Approved
                              </span>
                          <span @click="approvedUser(item)"
                                v-if="item.approved ==='false'"
                                style="cursor: pointer;"
                                class="badge badge-soft-danger text-uppercase status-badge">
                                <i class="mdi mdi-close-circle font-size-10 me-1"></i>Not Approved
                              </span>
                        </td>

                        <td>
                          <div class="btn-group" role="group">
                            <button type="button" class="btn btn-sm btn-outline-secondary dropdown-toggle" data-bs-toggle="dropdown">
                              <i class="mdi mdi-dots-horizontal"></i>
                            </button>
                            <ul class="dropdown-menu">
                              <li v-if="getRight('EDIT USER')">
                                <a class="dropdown-item" @click="openEditModal(item)">
                                  <i class="mdi mdi-pencil me-2"></i>Edit Details
                                </a>
                              </li>
                              <li v-if="getRight('RESET PASSWORD')">
                                <a class="dropdown-item" @click="openResetPasswordModal(item)">
                                  <i class="mdi mdi-key-change me-2"></i>Reset Password
                                </a>
                              </li>
                              <li v-if="getRight('MANAGE SIGNATURE')">
                                <a class="dropdown-item" @click="openSignatureModal(item)">
                                  <i class="mdi mdi-draw me-2"></i>{{item.signature ? 'Update' : 'Upload'}} Signature
                                </a>
                              </li>

                              <li v-if="getRight('LIQUOR SIGNATORY')">
                                <a class="dropdown-item" @click="openLiquorSignatoryModal(item)">
                                  <i class="mdi mdi-certificate me-2"></i>Liquor Signatory Setup
                                </a>
                              </li>

                              <li v-if="getRight('DISABLE USER')">
                                <a class="dropdown-item" :class="item.status==='Active' ? 'text-danger' : 'text-success'" @click="openDisableModal(item)">
                                  <i :class="item.status==='Active' ? 'mdi mdi-account-off' : 'mdi mdi-account-check'" class="me-2"></i>
                                  {{item.status==='Active' ? 'Disable' : 'Enable'}} User
                                </a>
                              </li>
                              <li><hr class="dropdown-divider"></li>
                              <li>
                                <a class="dropdown-item" @click="logs(item.idNo,item.names)">
                                  <i class="mdi mdi-account-details me-2"></i>View Logs
                                </a>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <!-- Loading State -->
                    <div v-if="loading" class="card-body px-5 d-flex flex-column justify-items-center align-items-center text-center">
                      <div class="p-5 py-0 pt-3">
                        <div class="p-5">
                          <div class="spinner-border text-info m-1" role="status">
                            <span class="sr-only text-uppercase">Loading...</span>
                          </div>
                        </div>
                      </div>
                      <h4 class="text-uppercase">Loading Data</h4>
                      <div class="col-sm-12 col-md-8 col-lg-5">
                        <p>We are fetching the data for you. It will be ready soon. Please wait and have fun. Thank you for your interest.</p>
                      </div>
                    </div>

                    <!-- No Results -->
                    <div v-if="filteredUsers.length<1 && loading===false" class="card-body d-sm-none d-md-block px-5 d-flex flex-column justify-items-center align-items-center text-center">
                      <div class="p-5 py-0 pt-3">
                        <img :src="'./assets/images/no-results.png'" class="img mb-4" alt="No search results"/>
                      </div>
                      <h4>No Results To Show</h4>
                      <p>Sorry, we could not find any results that match your search or filter criteria. Please try using different keywords or filters.</p>
                    </div>

                    <!-- Enhanced Pagination -->
                    <div class="card-footer bg-white">
                      <nav aria-label="Page navigation example" class="d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center">
                            <span class="pr-3 pb-0 mb-0 font-13px">
                              <span>Showing {{startIndex + 1}} to {{Math.min(endIndex, filteredUsers.length)}} of {{filteredUsers.length}} entries</span>
                            </span>
                          <select class="form-select w-auto font-13px ms-3" v-model="pageSize">
                            <option value="10">10 Rows</option>
                            <option value="25">25 Rows</option>
                            <option value="50">50 Rows</option>
                            <option value="100">100 Rows</option>
                            <option value="150">150 Rows</option>
                            <option value="200">200 Rows</option>
                          </select>
                        </div>

                        <ul class="pagination">
                          <li class="page-item" :class="{ disabled: currentPage === 1 }">
                            <a class="page-link" tabindex="-1" @click="prevPage" :disabled="currentPage === 1">Previous</a>
                          </li>
                          <li v-for="page in pagination(currentPage, totalPages, 3)" :key="page" class="page-item" :class="{ active: currentPage === page }">
                            <span v-if="page === '...'" class="page-link">{{ page }}</span>
                            <a v-else class="page-link" @click="goToPage(page)">{{ page }}</a>
                          </li>
                          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                            <a class="page-link" @click="nextPage" :disabled="currentPage === totalPages">Next</a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>
          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- Download Progress Modal -->
      <div class="modal fade" id="downloadProgressModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header bg-primary text-white">
              <h5 class="modal-title">
                <i class="bx bxs-download me-2"></i>Downloading All Users
              </h5>
            </div>
            <div class="modal-body">
              <div class="text-center mb-3">
                <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem;" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <h5>Please wait while we download your users...</h5>
                <p class="text-muted">This may take several minutes depending on the amount of data.</p>
              </div>

              <div class="progress mb-3" style="height: 25px;">
                <div
                    class="progress-bar progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    :style="{ width: downloadProgress.percentage + '%' }"
                    :aria-valuenow="downloadProgress.percentage"
                    aria-valuemin="0"
                    aria-valuemax="100">
                  {{ downloadProgress.percentage }}%
                </div>
              </div>

              <div class="d-flex justify-content-between text-muted small">
                <span>Page {{ downloadProgress.current }} of {{ downloadProgress.total }}</span>
                <span>{{ downloadProgress.records }} records downloaded</span>
              </div>

              <div class="alert alert-info mt-3 d-flex align-items-center" role="alert">
                <i class="bx bx-info-circle me-2"></i>
                <small>Please do not close this window or navigate away.</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
              © Best Birdy
            </div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Best Birdy Billing system.
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->
  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>

  <!-- Modal Components -->
  <EditUserModal
      :show="showEditModal"
      :selectedUser="selectedUser"
      :categories="categories"
      :subCounties="subCounties"
      :wards="wards"
      :zones="zones"
      :systems="systems"
      :facilities="facilities"
      @close="closeEditModal"
      @save="handleUpdateUser"
      @subcounty-change="getWards"
      @system-change="handleEditSystemChange"
  />

  <ResetPasswordModal
      :show="showResetPasswordModal"
      :selectedUser="selectedUser"
      @close="closeResetPasswordModal"
      @reset="handleResetPassword"
  />

  <DisableUserModal
      :show="showDisableModal"
      :selectedUser="selectedUser"
      @close="closeDisableModal"
      @disable="handleDisableUser"
  />

  <SignatureModal
      :show="showSignatureModal"
      :selectedUser="selectedUser"
      @close="closeSignatureModal"
      @upload-signature="handleUploadSignature"
      @remove-signature="handleRemoveSignature"
  />

  <LiquorSignatoryModal
      :show="showLiquorSignatoryModal"
      :selectedUser="selectedUser"
      @close="closeLiquorSignatoryModal"
      @save-signatory-roles="handleSaveSignatoryRoles"
      @load-signatories="handleLoadSignatories"
      @open-signature-modal="openSignatureModalFromLiquor"
      ref="liquorSignatoryModal"
  />

  <TransactionModal
      :show="showTransactionModal"
      @close="closeTransactionModal"
  />
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import EditUserModal from "@/components/systemusers/modals/EditUserModal.vue";
import ResetPasswordModal from "@/components/systemusers/modals/ResetPasswordModal.vue";
import DisableUserModal from "@/components/systemusers/modals/DisableUserModal.vue";
import TransactionModal from "@/components/systemusers/modals/TransactionModal.vue";
import SignatureModal from "@/components/systemusers/modals/SignatureModal.vue";
import LiquorSignatoryModal from "@/components/systemusers/modals/LiquorSignatoryModal.vue";
import router from "@/router";
import {authUrl, base, biller, execute, executeDownload, getRight, hospital} from "@/api";
import moment from 'moment';

export default {
  name: "Users",
  components: {
    NavigationBar,
    EditUserModal,
    ResetPasswordModal,
    DisableUserModal,
    TransactionModal,
    SignatureModal,
    LiquorSignatoryModal
  },
  data() {
    return{
      download:'Download',
      permission:'',
      loading: false,
      // System & Facility data
      systems: [],
      facilities: [],
      selectedSystem: '',
      selectedFacilityFilter: '',
      // Enhanced filter states
      passwordFilter: '',
      statusFilter: '',
      signatureFilter: '',
      // Modal visibility states
      showEditModal: false,
      showResetPasswordModal: false,
      showDisableModal: false,
      showTransactionModal: false,
      showSignatureModal: false,
      showLiquorSignatoryModal: false,
      // Pagination
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      summary: {
        count: 0
      },
      selectedUser:{
        id:null,
        names:null,
        idNo:null,
        gender:null,
        category:null,
        requireOTP:null,
        phoneNumber:null,
        email:null,
        zone:null,
        subCountyID:null,
        subCountyName:null,
        wardID:null,
        wardName:null,
        status:null,
        approved:null,
        passwordExpiry:null,
        signature:null,
        isChairperson:null,
        isSecretary:null,
        systemID:null,
        facilityID:null,
        facilityAccess:null,
        facilityName:null,
        facilityCode:null
      },
      search:"",
      selectedItem: "",
      message:null,
      wards:[],
      users:[],
      categories:[{
        id: "",
        category: ""
      }],
      zones: [],
      subCounties:[],
      county: {
        id: null,
        countyID: null,
        countyName: null,
        tagline: null,
        smsusername: null,
        smspassword:null,
        contact: null,
        center: null,
        address: null,
        email: null,
        headline: null,
        tagline2: null,
        ussd: null,
        logo: null,
        bank: null,
        powered: null,
        stateLogo: null,
        QRLink:null,
        poweredByLogo:null,
        autoGeneratePassword:null,
      },

      // Download All functionality
      isDownloadingAll: false,
      downloadProgress: {
        current: 0,
        total: 0,
        percentage: 0,
        records: 0
      },
      allUsersData: []
    }
  },
  computed: {
    // Enhanced computed properties
    filteredUsers() {
      let filtered = this.users;

      // Apply search filter
      if (this.search) {
        const searchLower = this.search.toLowerCase();
        filtered = filtered.filter(user =>
            user.names.toLowerCase().includes(searchLower) ||
            user.email.toLowerCase().includes(searchLower) ||
            user.phoneNumber.includes(searchLower) ||
            user.idNo.includes(searchLower) ||
            user.category.toLowerCase().includes(searchLower)
        );
      }

      // Apply category filter
      if (this.selectedItem && this.selectedItem !== '') {
        filtered = filtered.filter(user => user.category === this.selectedItem);
      }

      // Apply status filter
      if (this.statusFilter) {
        filtered = filtered.filter(user => user.status === this.statusFilter);
      }

      // Apply password expiry filter
      if (this.passwordFilter) {
        filtered = filtered.filter(user => {
          const category = this.getPasswordExpiryCategory(user.passwordExpiry);
          return category === this.passwordFilter;
        });
      }

      // Apply signature filter
      if (this.signatureFilter) {
        if (this.signatureFilter === 'with') {
          filtered = filtered.filter(user => user.signature && user.signature.trim() !== '');
        } else if (this.signatureFilter === 'without') {
          filtered = filtered.filter(user => !user.signature || user.signature.trim() === '');
        }
      }

      return filtered;
    },

    paginatedUsers() {
      const start = this.startIndex;
      const end = this.endIndex;
      return this.filteredUsers.slice(start, end);
    },

    passwordStats() {
      const stats = {
        critical: 0,
        warning: 0,
        good: 0,
        expired: 0
      };

      this.users.forEach(user => {
        const category = this.getPasswordExpiryCategory(user.passwordExpiry);
        stats[category]++;
      });

      return stats;
    },

    signatureStats() {
      const stats = {
        total: this.users.length,
        withSignature: 0,
        withoutSignature: 0,
        percentage: 0
      };

      this.users.forEach(user => {
        if (user.signature && user.signature.trim() !== '') {
          stats.withSignature++;
        } else {
          stats.withoutSignature++;
        }
      });

      stats.percentage = stats.total > 0
          ? Math.round((stats.withSignature / stats.total) * 100)
          : 0;

      return stats;
    },

    // Pagination computed properties
    startIndex() {
      return (this.currentPage - 1) * this.pageSize;
    },
    endIndex() {
      return this.currentPage * this.pageSize;
    },
  },
  watch: {
    // Pagination watcher
    pageSize(newPageSize) {
      this.totalPages = Math.ceil(this.filteredUsers.length / newPageSize);
      this.currentPage = 1;
    },
    selectedItem: {
      handler() {
        this.getUsers(this.selectedItem);
      }
    },
    search: {
      handler() {
        this.getUsers("");
      }
    },
    // Watch facility filter for hospital
    selectedFacilityFilter: {
      handler() {
        this.getUsers("");
      }
    },
    // Watch for filter changes
    passwordFilter: {
      handler() {
        this.currentPage = 1;
        this.totalPages = Math.ceil(this.filteredUsers.length / this.pageSize);
      }
    },
    statusFilter: {
      handler() {
        this.currentPage = 1;
        this.totalPages = Math.ceil(this.filteredUsers.length / this.pageSize);
      }
    },
    signatureFilter: {
      handler() {
        this.currentPage = 1;
        this.totalPages = Math.ceil(this.filteredUsers.length / this.pageSize);
      }
    },
    filteredUsers: {
      handler() {
        this.totalPages = Math.ceil(this.filteredUsers.length / this.pageSize);
      }
    }
  },
  mounted() {
    this.permission = sessionStorage.getItem("permission")
    this.getSystems()
    this.getFacilities()
    this.getUsers("")
    this.getCategories()
    this.getSubCounties()
    this.menuAccess()
    this.getCounty()
  },
  methods:{
    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num || 0)
    },

    // ============================================================================
    // System & Facility Methods
    // ============================================================================

    getSystems() {
      const data = new FormData();
      data.append("function", "getSystems");
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.systems = res.data.data.systems || [];
            }
          })
          .catch((e) => {
            console.error("Error loading systems:", e.message);
          });
    },

    getFacilities() {
      const data = new FormData();
      data.append("function", "getFacilities");
      data.append("status", "Active");
      execute(data, hospital)
          .then((res) => {
            if (res.data.success) {
              this.facilities = res.data.data.facilities || [];
            }
          })
          .catch((e) => {
            console.error("Error loading facilities:", e.message);
          });
    },

    handleSystemFilterChange() {
      this.selectedFacilityFilter = '';
      if (this.selectedSystem == 2) {
        this.getFacilities();
      }
      this.getUsers("");
    },

    handleEditSystemChange(systemID) {
      // When system changes in edit modal, load facilities if hospital
      if (systemID == 2) {
        this.getFacilities();
      }
    },

    getSystemName(systemID) {
      if (!systemID) return 'Not Assigned';
      const system = this.systems.find(s => s.id == systemID);
      return system ? system.name : 'Unknown';
    },

    getSystemIcon(systemID) {
      switch (parseInt(systemID)) {
        case 1: return 'mdi mdi-cash-register';
        case 2: return 'mdi mdi-hospital-building';
        case 3: return 'mdi mdi-clipboard-check-outline';
        default: return 'mdi mdi-help-circle';
      }
    },

    getSystemBadgeClass(systemID) {
      switch (parseInt(systemID)) {
        case 1: return 'bg-success';
        case 2: return 'bg-info';
        case 3: return 'bg-warning';
        default: return 'bg-secondary';
      }
    },

    // Facility display helpers
    hasMultipleFacilities(user) {
      if (!user.facilityAccess || user.facilityAccess === 'ALL') return false;
      try {
        const facilities = JSON.parse(user.facilityAccess);
        return Array.isArray(facilities) && facilities.length > 1;
      } catch {
        return false;
      }
    },

    getAdditionalFacilityCount(user) {
      if (!user.facilityAccess) return 0;
      try {
        const facilities = JSON.parse(user.facilityAccess);
        return Array.isArray(facilities) ? facilities.length - 1 : 0;
      } catch {
        return 0;
      }
    },

    // ============================================================================
    // Download Methods
    // ============================================================================

    downloadCurrentPage() {
      if (this.filteredUsers.length === 0) {
        alert('No data available to download');
        return;
      }

      try {
        const csv = this.generateUsersCSV(this.paginatedUsers);

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', `Users_Page_${this.currentPage}_${moment().format('YYYY-MM-DD_HHmmss')}.csv`);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        alert(`Successfully downloaded ${this.paginatedUsers.length} users from current page`);
      } catch (error) {
        console.error('Download error:', error);
        alert('Failed to download data: ' + error.message);
      }
    },

    generateUsersCSV(data) {
      if (!data || data.length === 0) return '';

      const headers = [
        'NO.',
        'Name',
        'ID Number',
        'Category',
        'System',
        'Facility',
        'Phone Number',
        'Email',
        'Sub County',
        'Ward',
        'Zone',
        'Status',
        'Approved',
        'OTP Required',
        'Password Expiry',
        'Has Signature',
        'Last Seen',
        'Address'
      ];

      let csv = headers.join(',') + '\n';

      data.forEach((item, index) => {
        const row = [
          index + 1,
          this.escapeCSV(item.names),
          this.escapeCSV(item.idNo),
          this.escapeCSV(item.category),
          this.escapeCSV(this.getSystemName(item.systemID)),
          this.escapeCSV(item.facilityName || (item.facilityAccess === 'ALL' ? 'All Facilities' : 'N/A')),
          this.escapeCSV(item.phoneNumber),
          this.escapeCSV(item.email),
          this.escapeCSV(item.subCountyName),
          this.escapeCSV(item.wardName),
          this.escapeCSV(item.zone),
          this.escapeCSV(item.status),
          this.escapeCSV(item.approved),
          this.escapeCSV(item.requireOTP),
          this.escapeCSV(item.passwordExpiry),
          item.signature ? 'Yes' : 'No',
          this.escapeCSV(item.lastSeen),
          this.escapeCSV(item.address)
        ];
        csv += row.join(',') + '\n';
      });

      return csv;
    },

    escapeCSV(value) {
      if (value === null || value === undefined) return '';
      const stringValue = String(value);
      if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
        return '"' + stringValue.replace(/"/g, '""') + '"';
      }
      return stringValue;
    },

    async downloadAllUsers() {
      if (!this.summary || this.summary.count === 0) {
        alert('No users available to download');
        return;
      }

      const isConfirmed = confirm(
          `You are about to download all ${this.numberFormat(this.summary.count)} users. This may take several minutes. Do you want to continue?`
      );

      if (!isConfirmed) return;

      let progressModal = null;

      try {
        this.isDownloadingAll = true;
        this.allUsersData = [];

        const batchSize = 1000;
        const totalRecords = parseInt(this.summary.count);
        const totalPages = Math.ceil(totalRecords / batchSize);

        this.downloadProgress = {
          current: 0,
          total: totalPages,
          percentage: 0,
          records: 0
        };

        const modalElement = document.getElementById('downloadProgressModal');
        progressModal = new bootstrap.Modal(modalElement);
        progressModal.show();

        for (let page = 1; page <= totalPages; page++) {
          try {
            this.downloadProgress.current = page;
            this.downloadProgress.percentage = Math.round((page / totalPages) * 100);

            const pageData = await this.fetchUsersPage(page, batchSize);

            if (pageData && pageData.length > 0) {
              this.allUsersData = [...this.allUsersData, ...pageData];
              this.downloadProgress.records = this.allUsersData.length;
            }

            await this.delay(50);

          } catch (error) {
            console.error(`Error fetching page ${page}:`, error);

            const continueDownload = confirm(
                `Error fetching page ${page} of ${totalPages}. Do you want to continue with the users already downloaded (${this.allUsersData.length} records)?`
            );

            if (!continueDownload) {
              throw new Error('Download cancelled by user');
            }

            break;
          }
        }

        if (this.allUsersData.length > 0) {
          const csv = this.generateUsersCSV(this.allUsersData);

          const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
          const link = document.createElement('a');
          const url = URL.createObjectURL(blob);

          const fileName = `All_Users_${moment().format('YYYY-MM-DD_HHmmss')}.csv`;

          link.setAttribute('href', url);
          link.setAttribute('download', fileName);
          link.style.visibility = 'hidden';

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          await this.delay(500);

          alert(`Successfully downloaded ${this.allUsersData.length} users!`);
        } else {
          alert('No users found to download');
        }

      } catch (error) {
        console.error('Download all error:', error);
        alert('Failed to download all users: ' + error.message);
      } finally {
        if (progressModal) {
          progressModal.hide();
        }

        const modalElement = document.getElementById('downloadProgressModal');
        if (modalElement) {
          const existingModal = bootstrap.Modal.getInstance(modalElement);
          if (existingModal) {
            existingModal.hide();
          }
        }

        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
          backdrop.remove();
        }

        document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());

        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';

        this.isDownloadingAll = false;
        this.allUsersData = [];
        this.downloadProgress = {
          current: 0,
          total: 0,
          percentage: 0,
          records: 0
        };
      }
    },

    async fetchUsersPage(page, rowsPerPage) {
      const data = new FormData();
      data.append("function", "getUsersPaginated");
      data.append("page", page);
      data.append("rows_per_page", rowsPerPage);
      data.append("category", "");
      data.append("search", "");

      const res = await execute(data, authUrl);

      if (res.data.success) {
        return res.data.data.users || [];
      } else {
        throw new Error(res.data.message || 'Failed to fetch page data');
      }
    },

    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    // ============================================================================
    // Modal Control Methods
    // ============================================================================

    openEditModal(user) {
      this.selectedUser = { ...user };
      this.getSubCounties();
      this.getWards(user.subCountyID);

      // IMPORTANT: Load facilities if user is hospital system
      if (user.systemID == 2 || !user.systemID) {
        this.getFacilities();
      }

      this.showEditModal = true;
    },

    closeEditModal() {
      this.showEditModal = false;
    },

    openResetPasswordModal(user) {
      this.selectedUser = user;
      this.showResetPasswordModal = true;
    },

    closeResetPasswordModal() {
      this.showResetPasswordModal = false;
    },

    openDisableModal(user) {
      this.selectedUser = user;
      this.showDisableModal = true;
    },

    closeDisableModal() {
      this.showDisableModal = false;
    },

    closeTransactionModal() {
      this.showTransactionModal = false;
    },

    openSignatureModal(user) {
      this.selectedUser = user;
      this.showSignatureModal = true;
    },

    closeSignatureModal() {
      this.showSignatureModal = false;
    },

    openLiquorSignatoryModal(user) {
      this.selectedUser = user;
      this.showLiquorSignatoryModal = true;
    },

    closeLiquorSignatoryModal() {
      this.showLiquorSignatoryModal = false;
    },

    openSignatureModalFromLiquor(user) {
      this.closeLiquorSignatoryModal();
      this.selectedUser = user;
      this.showSignatureModal = true;
    },

    // ============================================================================
    // Event Handlers for Modal Actions
    // ============================================================================

    handleUpdateUser(userData) {
      this.updateUser(userData);
      this.closeEditModal();
    },

    handleResetPassword(passwordData) {
      this.resetPassword(passwordData);
      this.closeResetPasswordModal();
    },

    handleDisableUser(status) {
      this.disable(status);
      this.closeDisableModal();
    },

    handleUploadSignature(signatureData) {
      this.uploadSignature(signatureData);
    },

    handleRemoveSignature(user) {
      this.removeSignature(user);
    },

    handleSaveSignatoryRoles(roleData) {
      this.saveSignatoryRoles(roleData);
    },

    handleLoadSignatories(subCountyID) {
      this.getSubCountySignatories(subCountyID);
    },

    // ============================================================================
    // Signature Methods
    // ============================================================================

    getSignatureUrl(signature) {
      if (!signature) return '';
      if (signature.startsWith('http')) {
        return signature;
      }
      return base+`/authentication/assets/signatures/${signature}`;
    },

    handleSignatureError(event) {
      event.target.style.display = 'none';
      const parent = event.target.closest('.signature-status');
      if (parent) {
        parent.innerHTML = `
          <span class="badge badge-soft-danger signature-badge">
            <i class="mdi mdi-close-circle font-size-10 me-1"></i>File Missing
          </span>
          <br>
          <small class="text-muted">File not found</small>
        `;
      }
    },

    viewSignature(signature) {
      if (signature) {
        const signatureUrl = this.getSignatureUrl(signature);
        window.open(signatureUrl, '_blank', 'width=600,height=400,scrollbars=yes,resizable=yes');
      }
    },

    // ============================================================================
    // API Calls
    // ============================================================================

    getCounty(){
      const data = new FormData();
      data.append("function", "getCounty");
      execute(data,authUrl)
          .then((res) =>{
            if (res.data.success) {
              this.county = res.data.data.county
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    getSubCountySignatories(subCountyID) {
      const data = new FormData();
      data.append("function", "getSubCountySignatories");
      data.append("subCountyID", subCountyID);

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              if (this.$refs.liquorSignatoryModal) {
                this.$refs.liquorSignatoryModal.updateCurrentSignatories(res.data.data.signatories);
              }
            } else {
              console.error("Failed to load signatories:", res.data.message);
            }
          })
          .catch((e) => {
            console.error("Error loading signatories:", e.message);
          });
    },

    saveSignatoryRoles(roleData) {
      this.message = null;
      const data = new FormData();
      data.append("function", "updateLiquorSignatoryRoles");
      data.append("userId", roleData.userId);
      data.append("idNo", roleData.idNo);
      data.append("names", roleData.names);
      data.append("subCountyID", roleData.subCountyID);
      data.append("subCountyName", roleData.subCountyName);
      data.append("isChairperson", roleData.isChairperson ? "true" : "false");
      data.append("isSecretary", roleData.isSecretary ? "true" : "false");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              const userIndex = this.users.findIndex(user => user.id === roleData.userId);
              if (userIndex !== -1) {
                this.users[userIndex].isChairperson = roleData.isChairperson;
                this.users[userIndex].isSecretary = roleData.isSecretary;
              }

              this.selectedUser.isChairperson = roleData.isChairperson;
              this.selectedUser.isSecretary = roleData.isSecretary;

              if (this.$refs.liquorSignatoryModal) {
                this.$refs.liquorSignatoryModal.handleSaveSuccess(res.data.message);
              }

              this.message = res.data.message;
              setTimeout(() => {
                this.message = null;
              }, 3000);

            } else {
              if (this.$refs.liquorSignatoryModal) {
                this.$refs.liquorSignatoryModal.handleSaveError(res.data.message);
              }
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            if (this.$refs.liquorSignatoryModal) {
              this.$refs.liquorSignatoryModal.handleSaveError(e.message);
            }
            this.message = e.message;
          });
    },

    // ============================================================================
    // Password Expiry Methods
    // ============================================================================

    getPasswordExpiryCategory(passwordExpiry) {
      const today = new Date();
      const expiryDate = new Date(passwordExpiry);
      const diffTime = expiryDate - today;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays < 0) return 'expired';
      if (diffDays <= 7) return 'critical';
      if (diffDays <= 30) return 'warning';
      return 'good';
    },

    getPasswordExpiryText(passwordExpiry) {
      const today = new Date();
      const expiryDate = new Date(passwordExpiry);
      const diffTime = expiryDate - today;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays < 0) return 'Expired';
      if (diffDays === 0) return 'Expires Today';
      if (diffDays === 1) return 'Expires Tomorrow';
      if (diffDays <= 7) return `${diffDays} days left`;
      if (diffDays <= 30) return `${diffDays} days left`;
      return `${diffDays} days left`;
    },

    getPasswordExpiryBadgeClass(passwordExpiry) {
      const category = this.getPasswordExpiryCategory(passwordExpiry);

      switch (category) {
        case 'expired':
          return 'badge-danger';
        case 'critical':
          return 'badge-danger';
        case 'warning':
          return 'badge-warning';
        case 'good':
          return 'badge-success';
        default:
          return 'badge-secondary';
      }
    },

    getPasswordExpiryRowClass(passwordExpiry) {
      const category = this.getPasswordExpiryCategory(passwordExpiry);

      switch (category) {
        case 'expired':
        case 'critical':
          return 'password-expiry-critical';
        case 'warning':
          return 'password-expiry-warning';
        case 'good':
          return 'password-expiry-good';
        default:
          return '';
      }
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') {
        return input;
      }

      const digits = input.replace(/\D/g, '');

      if (digits.length > 4) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }

      return input;
    },

    menuAccess(){
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Users");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data,biller)
          .then(() => {})
          .catch(() => {});
    },

    getRight(type){
      return getRight(type)
    },

    // ============================================================================
    // Pagination Methods
    // ============================================================================

    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) {
          end = totalPages;
        }
      }
      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) {
          start = 1;
        }
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) {
        pages.unshift("...");
      }
      if (end < totalPages) {
        pages.push("...");
      }

      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
      }
    },

    getHumanDate(dateData){
      const dateObject = new Date(Date.parse(dateData));
      return dateObject.toDateString();
    },

    logs(idNoUser,logsName){
      sessionStorage.setItem("idNoUser",idNoUser)
      sessionStorage.setItem("logsName",logsName)
      this.gotTo('user-logs')
    },

    gotTo(route){
      router.push(route)
    },

    // ============================================================================
    // Main Data Fetching Methods
    // ============================================================================

    getUsers(category){
      this.message = null
      this.loading = true
      this.users.splice(0)
      const data = new FormData();
      data.append("function", "getUsersPaginated");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("category", category);
      data.append("search", this.search);

      // Add system filter
      if (this.selectedSystem) {
        data.append("systemID", this.selectedSystem);
      }

      // Add facility filter
      if (this.selectedFacilityFilter) {
        data.append("facilityID", this.selectedFacilityFilter);
      }

      execute(data,authUrl)
          .then((res) =>{
            this.loading = false
            if (res.data.success) {
              this.users = res.data.data.users
              if(res.data.data.summary!=null){
                this.summary = res.data.data.summary
              }
              this.totalPages = Math.ceil(this.filteredUsers.length / this.pageSize);
            }else{
              this.message =res.data.message
            }
          })
          .catch((e) => {
            this.loading = false
            this.message =e.message
          });
    },

    getWards(subCountyID){
      this.message = null
      const data = new FormData();
      data.append("function", "getWards");
      data.append("subCountyID",subCountyID);
      execute(data,authUrl)
          .then((res) =>{
            if (res.data.success) {
              this.wards = res.data.data.wards
              this.getZones(subCountyID)
            }else{
              this.message =res.data.message
            }
          })
          .catch((e) => {
            this.message =e.message
          });
    },

    approvedUser(item){
      if(!getRight('APPROVE USER')){
        alert("Action Denied. You don't have the rights to approve")
        return;
      }

      this.selectedUser = item
      if(this.selectedUser.approved ==="true"){
        alert(this.selectedUser.names+ " has already been approved")
        return
      }

      if (!item.signature && this.isSignatureRequired(item.category)) {
        const uploadFirst = window.confirm(
            `${item.names} doesn't have a signature uploaded. ` +
            `Signatures are required for ${item.category} users. ` +
            `Would you like to upload their signature first?`
        );

        if (uploadFirst) {
          this.openSignatureModal(item);
          return;
        }
      }

      const confirmed = window.confirm("Are you sure you want to approve this user? "+ this.selectedUser.names);
      if (confirmed) {
        const data = new FormData();
        data.append("function", "approveUser");
        data.append("idNo", this.selectedUser.idNo);
        data.append("names", this.selectedUser.names);
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
        execute(data,authUrl).then((res) =>{
          if (res.data.success) {
            this.getUsers("")
          }else{
            this.message =res.data.message
          }
        }).catch((e) => {
          this.message =e.message
        });
      }
    },

    isSignatureRequired(category) {
      const signatureRequiredCategories = ['EXECUTIVE', 'REVENUE OFFICER', 'Secretariat'];
      return signatureRequiredCategories.includes(category);
    },

    getSubCounties(){
      this.message = null
      const data = new FormData();
      data.append("function", "getSubCounties");
      execute(data,authUrl).then((res) =>{
        if (res.data.success) {
          this.subCounties = res.data.data.subCounties
        }else{
          this.message =res.data.message
        }
      }).catch((e) => {
        this.message =e.message
      });
    },

    getCategories(){
      this.message = null
      const data = new FormData();
      data.append("function", "getCategories");
      execute(data,authUrl)
          .then((res) =>{
            if (res.data.success) {
              this.categories = res.data.data.categories
            }else{
              this.message =res.data.message
            }
          })
          .catch((e) => {
            this.message =e.message
          });
    },

    getZones(subCountyID){
      this.message = null
      const data = new FormData();
      data.append("function", "getZones");
      data.append("subCountyID", subCountyID);
      execute(data,authUrl)
          .then((res) =>{
            if (res.data.success) {
              this.zones = res.data.data.zones
            }else{
              this.message =res.data.message
            }
          })
          .catch((e) => {
            this.message =e.message
          });
    },

    updateUser(userData){
      this.message = null
      const data = new FormData();
      data.append("function", "updateUser");
      data.append("names", userData.names);
      data.append("email", userData.email);
      data.append("phoneNumber", userData.phoneNumber);
      data.append("category", userData.category);
      data.append("idNo", userData.idNo);
      data.append("gender", userData.gender || '');
      data.append("zone", userData.zone);
      data.append("requireOTP", userData.requireOTP);
      data.append("subCountyID", userData.subCountyID);
      data.append("subCountyName", userData.subCountyName);
      data.append("wardID", userData.wardID);
      data.append("wardName", userData.wardName);
      data.append("id", userData.id);
      // NEW: System and Facility fields
      data.append("systemID", userData.systemID || '');
      data.append("facilityID", userData.facilityID || '');
      data.append("facilityAccess", userData.facilityAccess || '');
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data,authUrl)
          .then((res) =>{
            if (res.data.success) {
              this.search = userData.names
              this.getUsers("")
            }else{
              this.message =res.data.message
            }
          })
          .catch((e) => {
            this.message =e.message
          });
    },

    resetPassword(passwordData){
      this.message = null
      const data = new FormData();
      data.append("function", "resetPassword");
      data.append("names", passwordData.names);
      data.append("email", passwordData.email);
      data.append("phoneNumber", passwordData.phoneNumber);
      data.append("category", passwordData.category);
      data.append("idNo", passwordData.idNo);
      data.append("zone", passwordData.zone);
      data.append("subCountyID", passwordData.subCountyID);
      data.append("subCountyName", passwordData.subCountyName);
      data.append("wardID", passwordData.wardID);
      data.append("wardName", passwordData.wardName);
      data.append("id", passwordData.id);
      data.append("password", passwordData.password);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data,authUrl)
          .then((res) =>{
            if (res.data.success) {
              this.search = passwordData.names
              this.getUsers("")
            }else{
              this.message =res.data.message
            }
          })
          .catch((e) => {
            this.message =e.message
          });
    },

    disable(status){
      this.message = null
      const data = new FormData();
      data.append("function", "disable");
      data.append("status", status);
      data.append("names", this.selectedUser.names);
      data.append("email", this.selectedUser.email);
      data.append("phoneNumber", this.selectedUser.phoneNumber);
      data.append("category", this.selectedUser.category);
      data.append("idNo", this.selectedUser.idNo);
      data.append("zone", this.selectedUser.zone);
      data.append("subCountyID", this.selectedUser.subCountyID);
      data.append("subCountyName", this.selectedUser.subCountyName);
      data.append("wardID", this.selectedUser.wardID);
      data.append("wardName", this.selectedUser.wardName);
      data.append("id", this.selectedUser.id);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data,authUrl)
          .then((res) =>{
            if (res.data.success) {
              this.search = this.selectedUser.names
              this.getUsers("")
            }else{
              this.message =res.data.message
            }
          })
          .catch((e) => {
            this.message =e.message
          });
    },

    downloadUsers(){
      this.download ="Please wait.."
      const data = new FormData();
      data.append("function", "downloadUsers");
      executeDownload(data,authUrl).then(response => {
        this.download ="Download"
        const link = document.createElement('a');
        link.href = URL.createObjectURL(response.data);
        link.download ="Users.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },

    uploadSignature(signatureData) {
      this.message = null;
      execute(signatureData, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.message = res.data.message;
              this.getUsers("");
              this.closeSignatureModal();

              setTimeout(() => {
                alert('Signature uploaded successfully!');
              }, 500);
            } else {
              this.message = res.data.message;
              alert('Error: ' + res.data.message);
            }
          })
          .catch((e) => {
            this.message = e.message;
            alert('Upload failed: ' + e.message);
          });
    },

    removeSignature(user) {
      this.message = null;
      const data = new FormData();
      data.append("function", "removeUserSignature");
      data.append("userId", user.id);
      data.append("idNo", user.idNo);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.message = res.data.message;
              this.getUsers("");
              this.closeSignatureModal();

              setTimeout(() => {
                alert('Signature removed successfully!');
              }, 500);
            } else {
              this.message = res.data.message;
              alert('Error: ' + res.data.message);
            }
          })
          .catch((e) => {
            this.message = e.message;
            alert('Remove failed: ' + e.message);
          });
    },
  },
}
</script>
<style scoped>
.password-expiry-critical {
  background: rgba(220, 38, 38, 0.05);
  border-left: 3px solid #dc2626;
}
.password-expiry-warning {
  background: rgba(245, 158, 11, 0.05);
  border-left: 3px solid #f59e0b;
}
.password-expiry-good {
  background: rgba(34, 197, 94, 0.05);
  border-left: 3px solid #22c55e;
}
.user-card {
  transition: all 0.3s ease;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
.user-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0,0,0,0.15);
}
.status-badge {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.avatar-circle {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  background-color: #3b82f6;
  color: white;
  border: 2px solid rgba(255,255,255,0.2);
}
.password-days-badge {
  font-size: 10px;
  padding: 4px 8px;
  border-radius: 12px;
  font-weight: 600;
}
.filter-section {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
}
.stats-card {
  background-color: white;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.action-btn {
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 500;
  margin: 2px;
  transition: all 0.2s ease;
}
.action-btn:hover {
  transform: translateY(-1px);
}
.table-container {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);
}
.badge-danger {
  background-color: #dc3545;
  color: white;
}
.badge-warning {
  background-color: #f59e0b;
  color: white;
}
.badge-success {
  background-color: #22c55e;
  color: white;
}
.badge-secondary {
  background-color: #6b7280;
  color: white;
}
.password-expiry-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

/* Signature-related styles */
.signature-thumbnail {
  width: 40px;
  height: 25px;
  object-fit: contain;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.signature-thumbnail:hover {
  transform: scale(1.1);
  border-color: #3b82f6;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);
}

.signature-status {
  min-width: 120px;
}

.signature-badge {
  font-size: 10px;
  padding: 4px 8px;
  border-radius: 12px;
  font-weight: 600;
}

/* Enhanced table styling */
.table th {
  background-color: #f8fafc;
  color: #374151;
  font-weight: 600;
  letter-spacing: 0.025em;
  border: none;
  padding: 15px 10px;
  font-size: 13px;
  text-transform: uppercase;
}

.table td {
  padding: 12px 10px;
  vertical-align: middle;
  border-color: #e5e7eb;
}

.table-hover tbody tr:hover {
  background-color: rgba(59, 130, 246, 0.04);
}

/* Search and filter styling */
.form-control:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 0.2rem rgba(59, 130, 246, 0.15);
}

.form-select:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 0.2rem rgba(59, 130, 246, 0.15);
}

/* Button styling */
.btn-primary {
  background-color: #3b82f6;
  border-color: #3b82f6;
  border-radius: 6px;
  font-weight: 500;
  letter-spacing: 0.025em;
  transition: all 0.2s ease;
}

.btn-primary:hover {
  background-color: #2563eb;
  border-color: #2563eb;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
}

/* Dropdown menu styling */
.dropdown-menu {
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  padding: 6px 0;
}

.dropdown-item {
  padding: 8px 16px;
  transition: all 0.15s ease;
  font-size: 14px;
}

.dropdown-item:hover {
  background-color: #f3f4f6;
  color: #374151;
}

/* Pagination styling */
.pagination .page-link {
  border-radius: 6px;
  margin: 0 2px;
  border: 1px solid #d1d5db;
  color: #374151;
  font-weight: 500;
  font-size: 14px;
}

.pagination .page-item.active .page-link {
  background-color: #3b82f6;
  border-color: #3b82f6;
  color: white;
}

.pagination .page-link:hover {
  background-color: #f3f4f6;
  border-color: #d1d5db;
  color: #374151;
}

/* Modal styling */
.modal-content {
  border-radius: 12px;
  border: none;
  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.1);
}

.modal-header {
  background-color: #f8fafc;
  color: #374151;
  border-radius: 12px 12px 0 0;
  border-bottom: 1px solid #e5e7eb;
}

/* Loading and empty states */
.spinner-border {
  width: 3rem;
  height: 3rem;
}

/* Button group styling */
.btn-group .btn {
  white-space: nowrap;
}

.btn-group .btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

/* Download Progress Modal styling */
#downloadProgressModal .modal-body {
  padding: 2rem;
}

#downloadProgressModal .progress {
  background-color: #e9ecef;
}

#downloadProgressModal .progress-bar {
  font-weight: 600;
  font-size: 0.875rem;
}

/* Responsive improvements */
@media (max-width: 768px) {
  .stats-card {
    margin-bottom: 15px;
  }

  .card-header .row > div {
    margin-bottom: 10px;
  }

  .table-responsive {
    font-size: 14px;
  }

  .password-days-badge {
    font-size: 9px;
    padding: 3px 6px;
  }

  .signature-thumbnail {
    width: 30px;
    height: 20px;
  }
}

/* Custom animations */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card {
  animation: slideIn 0.6s ease-out;
}

/* Enhanced visual feedback */
.table tbody tr {
  transition: all 0.3s ease;
}

.avatar-title {
  transition: all 0.3s ease;
}

.avatar-title:hover {
  transform: scale(1.1);
}
</style>